<template>
    <!-- 评价页面 -->
    <div class="bcw">
        <div class="clear model-box fs2">
            <span class="left">课程评价：</span>    
            <van-rate class="left mln" v-model="value" />  
            <span class="left c9 mlm">{{evaluationText}}</span>
        </div>
        
        <van-cell-group>
        <van-field
            v-model="text"
            type="textarea"
            placeholder="请输入留言"
            rows="5"
            autosize
        />
        </van-cell-group>

        <!-- 图片上传 -->
        <div class="model-box" v-if="false">            
            <div class="van-clearfix">
                <!-- 图片预览 -->
                <div class="van-sku-img-uploader__img" v-for="(url,index) in imgList" :key="index">
                    <img :src="url" ref="goodsImg">
                    <i class="van-icon van-icon-clear van-sku-img-uploader__delete" @click.stop="delImg(index)"></i>
                </div>

                <!-- 上传 -->
                <van-uploader :after-read="onRead" class="van-tina-img-uploader__img tac ">
                    <van-icon name="photograph" />
                </van-uploader>
            </div>                        
        </div>

        <van-button type="warning" @click="release()" size="large" class="fs3 mtm">发布</van-button>
    </div>
</template>
<script>
import Vue from 'vue';
import { Rate,Uploader ,Sku,Toast } from 'vant';
Vue.use(Rate).use(Uploader).use(Sku).use(Toast);
import CycleCard from '@/components/CycleCard'
export default {
    name: 'CycleList',
    components: {
        CycleCard
    },
    data(){
      return {
        value:5,
        text:'',
        imgList: [],  //图片列表
        coursetype:''   //类型
      }
    },
    created(){
        var courseType = this.$route.params.courseType
        if(courseType=='clubGroupCourse'){
            //团课
            this.coursetype='club'
        }else if(courseType=='clubPtCourse'){
            //私教课
            this.coursetype='coach'
        }
    },
    methods: {
        onRead(file) {
            // 图片预览
            this.imgList.push(file.content)
        },
        delImg(index) {
            // 删除图片
            // this.size = this.size - this.imgList[index].file.size;//总大小
            this.imgList.splice(index, 1);
            // if (this.limit !== undefined) this.limit = 6-this.imgList.length;
        },
        release(){
            // 评价
            this.$http.post('course_reviews/post',{
                courseId:this.$route.params.courseId,
                rating:this.value,
                content:this.text,
                courseType:this.coursetype,
                relateId:this.$route.params.relateId,
                orderId:this.$route.params.orderId
            }).then(res => {
                if(!res.data.code){
                    Toast.success('评价成功！')
                    this.$router.go(-1)
                }else{
                    Toast.fail({
                        message:res.data.message
                    }) 
                }
            })
        }
    },
    computed: {    
      evaluationText: function(){
        // 评价文字
        if(this.value=='1'){
            return "非常差"
        }else if(this.value=='2'){
            return "差"
        }else if(this.value=='3'){
            return "一般"
        }else if(this.value=='4'){
            return "好"
        }else if(this.value=='5'){
            return "非常好"
        }
      },
    }
}
</script>
<style lang="less" scoped>
.van-tina-img-uploader__img{
    height: 0.6rem;
    line-height: 0.6rem;
    width: 0.6rem;
    float: left;
    margin: 0.1rem 0.1rem 0 0;
    position: relative;
    border: 0.01rem dashed #eee;
    text-align: center;
    color: #999;
}
.van-rate__item{
    margin-right: 0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Evaluation.vue